// simply copied from https://github.com/n6g7/redux-saga-firebase/tree/master/example/src/redux/actions
export const types = {
  SET_REGISTRATION_TOKEN: "SET_REGISTRATION_TOKEN",
};

export const setRegistrationToken = (token) => ({
  type: types.SET_REGISTRATION_TOKEN,
  token,
});
